import { CurrencyPipe } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import {
  AnalyticsService,
  CertificateListService,
  NotificationService,
  BalanceService,
  WalletService,
  ProfileService,
  NotificationKeys,
  PaymentStatus,
  Processors,
  ResponseStatus,
  Services,
  ShareType,
  UserTypes,
  StorageKeys,
  scrollBehaviours,
  URLS,
  CertificateStatus,
  Units,
  BooleanStringValues,
  ErrorCodes,
  ShareStatuses,
} from "@core";
import { TranslateService } from "@ngx-translate/core";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { API_Statuses } from "src/app/core/config/api-response.config";
import { BrowserStorageKeys } from "src/app/core/config/browser-storage-keys.config";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import { CertificateShareOptions } from "src/app/core/config/share-radio-button-options.config";
import { ShareCertificateOptions } from "src/app/core/enums/share-certificate-options.enum";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { ExamCountrySetupComponent } from "src/app/shared/helpers/global/exam-country-setup/exam-country-setup.component";

@Component({
  selector: "digicert-share-certificate",
  templateUrl: "./share-certificate.component.html",
  styleUrls: ["./share-certificate.component.less"],
  standalone: false,
})
export class ShareCertificateComponent implements OnInit, OnDestroy {
  @ViewChild("shareHistory") shareHistory!: ElementRef;
  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.checkScreenSize();
  }

  certificateList: any[] = [];
  shareCertificateOptions: any[] = CertificateShareOptions;
  selectedCertificate: any[] = [];
  selectedCertificate_: any[] = [];
  sharedHistory: any[] = [];
  sharedHistorySkeleton: any[] = new Array(7);
  emailInstitutionList: any[] = [];
  institutions: any[] = [];

  viewselectedCertificate: boolean = false;
  viewselectedCertificate_: boolean = false;
  showCertificate: boolean = false;
  showCertificate_: boolean = false;
  isloading: boolean = false;
  isSkeleton: boolean = false;
  loading: boolean = false;
  errorStatus: boolean = false;
  walletCreditModal: boolean = false;
  paymentModal: boolean = false;
  isSmallScreen: boolean = false;
  formView = true;
  isInstitutionLoading = false;
  isAddressNotAvailable: boolean = false;
  isInstitutionNotAvailable: boolean = false;
  displayScrollToTop: boolean = false;
  userInformationModal: boolean = false;
  disableRequestConfirmation: boolean = false;
  processStepsModal: boolean = false;

  currency_unit_rate: any;
  serviceCharge: any;
  candidateInformation: any;
  payment_currency: any;
  shareOptions: any = ShareCertificateOptions;
  countries: any;
  userCountry: any;
  @ViewChild(ExamCountrySetupComponent) examCountrySetup!: ExamCountrySetupComponent;
  examCountrySetupModal: boolean = false;

  shareCertificateOptionSelected: string = ShareCertificateOptions.INDIVIDUAL;
  candidate_id: string = "";
  candidate_id_: string = "";
  error: string = "";
  pipeDateFormart: string = "d MMM";
  institutionAvailablityInfo: string =
    "PROVISIONING.SHARE.TOGGLE_SWITCH_DESCRIPTION"; //"Toggle switch if institution is not available"

  shareCost: number = 0;
  costInUnit: any;
  requestConfirmationCost: number = 0;
  current_page: number = 1;

  shareForm!: FormGroup;
  shareToInstitutionForm!: FormGroup;
  searchInstitutionsForm!: FormGroup;
  chargeNotificationModal?: NzModalRef;

  userTypes = UserTypes;
  services = Services;
  shareType = ShareType;
  shareStatuses = ShareStatuses;

  step: number = 0;

  constructor(
    private fb: FormBuilder,
    private certificateService: CertificateListService,
    private notify: NotificationService,
    private walletBalance: BalanceService,
    private modal: NzModalService,
    private wallet: WalletService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private profileSrv: ProfileService,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    private storageSrv: StorageService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {
    this.countries = this.certificateService.getLocalStorageCountry("ALL");
    const user = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    this.userCountry = this.countries.find((val: any) => val.code === user?.country);
  }

  ngOnInit(): void {
    this.buildShareForm();
    this.buildShareToInstitutionForm();
    this.buildSearchInstitutionForm();
    this.loadCertificate();
    this.loadSharedlogs();
    this.getServiceCost();
    this.getCurrencyUnitRate();
    this.confirmPayment();
    this.onClearFormData();
    this.checkScreenSize();
  }

  ngOnDestroy(): void {
    this.storageSrv.removeLocalStorageItem(BrowserStorageKeys.shareOption);
    this.storageSrv.removeLocalStorageItem(StorageKeys.DISPLAY_PAYMENT_STEP);
  }

  get scrollToHistory() {
    const scrollToElement = this.storageSrv.getcertificateShareContentID();
    if (scrollToElement === "shareHistory") {
      this.shareHistory?.nativeElement.scrollIntoView({ behavior: scrollBehaviours.SMOOTH });
      this.storageSrv.setCertificateShareContentID("");
    }

    return;
  }

  get checkInstitutionFormvaldity() {
    let valid: boolean = true;

    if (
      this.shareToInstitutionForm?.value?.certificate_ &&
      this.shareToInstitutionForm?.value?.institution_user_id
    ) {
      valid = false;
    } else if (
      this.shareToInstitutionForm?.value?.country &&
      this.shareToInstitutionForm?.value?.address &&
      this.shareToInstitutionForm?.value?.institution &&
      this.shareToInstitutionForm?.value?.certificate_ &&
      this.shareToInstitutionForm?.value?.institutionemail
    ) {
      valid = false;
    } else {
      valid = true;
    }

    return valid;
  }

  buildShareForm() {
    this.shareForm = this.fb.group({
      email: [
        { value: null, disabled: true },
        [Validators.required, Validators.email],
      ],
      certificate: [null, [Validators.required]],
      candidate_id: [null],
    });
  }

  buildShareToInstitutionForm() {
    this.shareToInstitutionForm = this.fb.group({
      certificate_: [null, [Validators.required]],
      candidate_id: [{ value: null, disabled: true }],
      switch: [false],
      additional_info: [{ value: null, disabled: true }],
      institution: [{ value: null, disabled: true }, [Validators.required]],
      country: [{ value: null, disabled: true }, [Validators.required]],
      address: [{ value: null, disabled: true }, [Validators.required]],
      verify_address: [{ value: null, disabled: true }, [Validators.required]],
      institution_user_id: [
        { value: null, disabled: true },
        [Validators.required],
      ],
      institutionemail: [
        { value: null, disabled: true },
        [Validators.required, Validators.email],
      ],
    });
  }

  buildSearchInstitutionForm() {
    this.searchInstitutionsForm = this.fb.group({
      search: [""],
    });
  }

  getShareTypeIcon(type: string) {
    if (type?.toLowerCase() === ShareType.INDIVIDUAL) {
      return URLS.USER_SHARE;
    }
    return URLS.INSTITUTION_SHARE;
  }

  getCurrencyUnitRate() {
    let userObject = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    this.currency_unit_rate = userObject.wallet.currency_unit_rate;
    this.payment_currency = userObject.wallet.payment_currency;
  }

  onClearFormData() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        const current_url = event.url;
        if (current_url !== pageRoutes.access.sharing) {
          this.shareForm.reset();
          this.shareToInstitutionForm.reset();
          this.profileSrv.clearInputDetailsTemporarily();
        }
      }
    });
  }

  loadCertificate() {
    let param = {
      page_size: 60,
    };

    this.certificateService
      .getCertificate(param)
      .then((res) => {
        this.certificateList = res?.data?.filter(
          (item: any) =>
            item?.status == CertificateStatus.ACTIVE &&
            item.identity_verified &&
            item.candidate?.ispicture == true,
        );

        this.certificateList?.map(
          (e) =>
            (e.new_name =
              e.candidate.candidate_number +
              " - " +
              e.candidate.surname +
              " " +
              e.candidate.firstname),
        );
        this.getTmpInputs();
        this.loading = false;
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  getCertificateID(id: any) {
    const certificate_id = this.certificateList.filter(
      (e: any) => e.candidate.id === id,
    );
    return certificate_id[0]?.id;
  }

  certificateView(x: string) {
    this.candidate_id = "";
    this.selectedCertificate = [];
    this.viewselectedCertificate = false;
    this.selectedCertificate = this.certificateList.filter(
      (item: any) => item.id == x,
    );
    this.selectedCertificate.forEach(
      (item: any) => (this.candidate_id = item.candidate.id),
    );
    this.showCertificate = true;

    if (x) {
      this.shareForm.get("email")?.enable();
    } else {
      this.shareForm.get("email")?.disable();
    }
  }

  certificateView_(y: string) {
    this.candidate_id_ = "";
    this.selectedCertificate_ = [];
    this.viewselectedCertificate_ = false;
    if (y === null) {
      this.disableFormControls();
      return;
    }
    this.selectedCertificate_ = this.certificateList.filter(
      (item: any) => item.id == y,
    );
    this.selectedCertificate_.forEach(
      (item: any) => (this.candidate_id_ = item.candidate.id),
    );
    this.showCertificate_ = true;
    if (this.selectedCertificate_.length) {
      this.enableFormControls();
    }
  }

  enableFormControls() {
    if (this.showCertificate_) {
      Object.keys(this.shareToInstitutionForm.controls).forEach((control) => {
        this.shareToInstitutionForm.get(control)?.enable();
      });
    }
  }

  disableFormControls() {
    Object.keys(this.shareToInstitutionForm.controls).forEach((control) => {
      if (control !== "certificate_") {
        this.shareToInstitutionForm.get(control)?.setValue("");
        this.shareToInstitutionForm.get(control)?.disable();
      }
    });
  }

  getTmpInputs() {
    let data = this.profileSrv.getInputDetailsTemporarily();
    if (data.certificate) {
      if (!data.country) {
        this.shareForm.patchValue({
          email: data.email,
          certificate: this.getCertificateID(data.candidate_id),
          candidate_id: data.candidate_id,
        });
        this.certificateView(this.getCertificateID(data.candidate_id));
      } else if (data.country) {
        this.shareToInstitutionForm.patchValue({
          certificate_: data.certificate,
          institution: data.institution,
          candidate_id: data.candidate_id,
          additional_info: data.additional_info,
          country: data.country,
          institutionemail: data.institutionemail,
          address: data.address,
        });
      }
    }
  }

  getServiceCost() {
    let services = JSON.parse(this.certificateService.getServiceCharges()!);
    if (!services) {
      this.wallet
        .walletServices()
        .then((res) => {
          this.certificateService.setServiceCharges(
            JSON.stringify(res?.data?.data),
          );
          this.setShareCharge(res?.data?.data);
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      this.setShareCharge(services);
    }
  }

  setShareCharge(data: any) {
    let services = data?.filter(
      (i: any) => i.item?.toLowerCase() == Services.SHARING,
    )[0];
    this.shareCost = services?.service_values?.filter(
      (i: any) => i.value_text?.toLowerCase() == Units.UNIT,
    )[0]?.value;
    let requestConfirmationServices = data?.filter(
      (i: any) => i.item?.toLowerCase() == Services.REQUEST_CONFIRMATION,
    )[0];
    this.requestConfirmationCost =
      requestConfirmationServices?.service_values?.filter(
        (i: any) => i.value_text?.toLowerCase() == Units.UNIT,
      )[0]?.value;
  }

  confirmPayment() {
    let processor = null;
    let reference = null;

    this.route.queryParams.subscribe((params) => {
      processor = params?.processor;
      reference = params?.reference;
      let paystackerrorMessage = "errorMessage";

      if (Object.keys(params).includes(paystackerrorMessage)) {
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.SHARE.PAYMENT_TRANSACTION_CANCELLED",
          ),
          NotificationKeys.BILLING,
        );
        this.router.navigateByUrl(this.router.url.split("?")[0]);
        return;
      }

      if (!processor && !reference) {
        return;
      }

      if (
        processor == Processors.FLUTTERWAVE &&
        params?.status != PaymentStatus.SUCCESSFUL
      ) {
        this.analytics.transactionCompleted('failed', Services.SHARING);
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.SHARE.PAYMENT_TRANSACTION_TEXT",
          ) +
            params.status +
            "!",
          NotificationKeys.BILLING,
        );
        this.router.navigateByUrl(this.router.url.split("?")[0]);
        return;
      }

      let body = {
        processor: processor,
        trxref: reference,
        reference: reference,
        transaction_id: params?.transaction_id
          ? params?.transaction_id
          : params?.tx_ref,
      };

      this.certificateService
        .confirmPayment(body)
        .then((res) => {
          this.loading = false;
          if (res.status === ResponseStatus.FAILED) {
            this.analytics.transactionCompleted('failed', Services.SHARING);
            this.notify.error("", res.message, NotificationKeys.BILLING);
            this.router.navigateByUrl(this.router.url.split("?")[0]);
            return;
          }
          this.analytics.transactionCompleted('success', Services.SHARING);

          let data = this.profileSrv.getInputDetailsTemporarily();
          if (data.share_type == ShareType.INSTITUTION) {
            this.shareToInstitutionForm.patchValue({
              certificate_: data.certificate,
              additional_info: data.additional_info,
              institution: data.institution,
              candidate_id: data.candidate_id,
              country: data.country,
              institutionemail: data.institutionemail,
              verify_address: data.address,
              address: data.address,
              institution_name: data.institution,
              institution_user_id: data.institution_user_id,
            });
          } else {
            this.shareForm.patchValue({
              email: data.email,
              certificate: data.candidate_id,
              candidate_id: data.candidate_id,
            });
          }
          this.confirmSubmission();
        })
        .catch((err) => {
          this.loading = false;
          console.warn(err);
        });
    });
  }

  submit(): void {
    // this.userInformationModal = false;
    this.processStepsModal = false;
    this.isloading = true;
    this.error = "";

    localStorage.removeItem(StorageKeys.DISPLAY_PAYMENT_STEP);

    this.shareForm.controls.email.markAsDirty();
    this.shareForm.controls.certificate.markAsDirty();

    this.shareForm.controls.email.updateValueAndValidity();
    this.shareForm.controls.certificate.updateValueAndValidity();

    if (
      this.shareForm.controls.email.invalid ||
      this.shareForm.controls.certificate.invalid
    ) {
      this.analytics.formSubmitted('share_certificate', 'invalid');
      this.isloading = false;
      return;
    }
    this.analytics.formSubmitted('share_certificate', 'valid');

    const body = {
      candidate_id: this.candidate_id,
      certificate: this.candidate_id,
      email: this.shareForm.controls.email.value,
    };

    this.profileSrv.clearInputDetailsTemporarily();
    this.profileSrv.storeInputDetailsTemporarily(body);
    this.onValidateEmail({ share_type: ShareType.INDIVIDUAL, ...body });

    setTimeout(() => {
      this.isloading = false;
    }, 2000);
  }

  confirmSubmission() {
    this.loading = true;
    let body: any;

    if (
      this.shareCertificateOptionSelected ===
        ShareCertificateOptions.REQUEST_CONFIRMATION ||
      this.storageSrv.getLocalStorageItem(BrowserStorageKeys.shareOption) ==
        ShareCertificateOptions.REQUEST_CONFIRMATION ||
      this.shareToInstitutionForm.controls.institution.value ||
      this.shareToInstitutionForm.controls.country.value
    ) {
      body = this.patchInstitutionForm();
    } else {
      body = {
        share_type: ShareType.INDIVIDUAL,
        email: this.shareForm.controls.email.value,
        certificate: this.shareForm.controls.certificate.value,
        candidate_id: this.shareForm.controls.candidate_id.value
          ? this.shareForm.controls.candidate_id.value
          : this.candidate_id,
        country: "",
        institution_name: "",
        address: "",
      };
    }

    this.certificateService
      .share(body)
      .then((res) => {
        this.loading = false;
        if (res.status === ResponseStatus.FAILED) {
          this.analytics.share('failed');
          this.notify.error("", res.message, NotificationKeys.SHARE);
          this.walletBalance.getbalance();
          this.errorStatus = true;
          return;
        }

        this.analytics.share('success');
        this.walletBalance.sendBalance(BooleanStringValues.FALSE);
        this.walletBalance.getbalance();
        this.errorStatus = false;
        this.step = 0;
        localStorage.removeItem(StorageKeys.DISPLAY_PAYMENT_STEP);
        this.notify.success("", res.message, NotificationKeys.SHARE);
        this.profileSrv.clearInputDetailsTemporarily();
        this.shareForm.reset();
        this.shareToInstitutionForm.reset();
        this.resetShareState();
        this.loadSharedlogs();
        this.onPaymentSuccessClearQueryParam();
      })
      .catch((err) => {
        this.loading = false;
        this.walletBalance.getbalance();
        this.error = err;
        if (err.status === API_Statuses[402] && err?.error?.data == ErrorCodes.FUND_WALLET) {
          this.walletCreditModal = true;
        }
      });
  }

  /**
   * Clears all cross-flow state so a completed share (or a switch between the
   * Individual / Request Confirmation options) never leaks a stale candidate,
   * certificate selection or persisted share option into the next flow. Without
   * this, `candidateInformation` and `candidate_id_` from a request confirmation
   * bleed into a subsequent individual share and break the rendered candidate.
   */
  resetShareState() {
    this.candidateInformation = null;
    this.candidate_id = "";
    this.candidate_id_ = "";
    this.selectedCertificate = [];
    this.selectedCertificate_ = [];
    this.showCertificate = false;
    this.showCertificate_ = false;
    this.viewselectedCertificate = false;
    this.viewselectedCertificate_ = false;
    this.storageSrv.removeLocalStorageItem(BrowserStorageKeys.shareOption);
  }

  onPaymentSuccessClearQueryParam() {
    const processor = "processor";

    this.route.queryParams.subscribe((param: any) => {
      if (Object.keys(param).includes(processor)) {
        this.router.navigateByUrl(this.router.url.split("?")[0]);
      }
    });
  }

  loadSharedlogs(): void {
    this.isloading = true;
    this.isSkeleton = true;
    let page_size = 7;
    let url = `?page=1&page_size=${page_size}`;

    this.certificateService
      .sharedCertificate(url)
      .then((res) => {
        if (res?.status === ResponseStatus.FAILED) {
          this.notify.info("", res?.message);
          this.isloading = false;
          this.isSkeleton = false;
          return;
        }

        this.current_page = res?.data?.pagination?.current_page;
        this.sharedHistory = res?.data?.data;
        this.isloading = false;
        this.isSkeleton = false;
      })
      .catch(() => {
        this.isloading = false;
      });
  }

  openModeOfPayments() {
    this.paymentModal = true;
  }

  cancelmodalContentbillingpayment() {
    this.walletCreditModal = false;
  }

  cancelPaymentOptionsModal() {
    this.paymentModal = false;
  }

  initiateFundingWallet() {
    this.walletCreditModal = false;
    this.openModeOfPayments();
  }

  initiateWallet(value: any) {
    if (value == Services.WALLET) {
      this.confirmSubmission();
    } else {
      this.paymentModal = false;
      location.assign(value);
    }
  }

  checkInstitutionFormValidity(isSwitchOff: boolean) {
    if (!isSwitchOff) {
      this.shareToInstitutionForm.controls.certificate_.markAsDirty();
      this.shareToInstitutionForm.controls.institution_user_id.markAsDirty();

      this.shareToInstitutionForm.controls.institution.clearValidators();
      this.shareToInstitutionForm.controls.country.clearValidators();
      this.shareToInstitutionForm.controls.address.clearValidators();
      this.shareToInstitutionForm.controls.institutionemail.clearValidators();

      this.shareToInstitutionForm.controls.certificate_.updateValueAndValidity();
      this.shareToInstitutionForm.controls.institution_user_id.updateValueAndValidity();
      this.shareToInstitutionForm.controls.institution.updateValueAndValidity();
      this.shareToInstitutionForm.controls.country.updateValueAndValidity();
      this.shareToInstitutionForm.controls.institutionemail.updateValueAndValidity();
      this.shareToInstitutionForm.controls.address.updateValueAndValidity();

      if (this.isAddressNotAvailable) {
        this.shareToInstitutionForm.controls.verify_address.markAsDirty();
        this.shareToInstitutionForm.controls.verify_address.updateValueAndValidity();
        return;
      }

      this.shareToInstitutionForm.controls.verify_address.clearValidators();
      this.shareToInstitutionForm.controls.verify_address.updateValueAndValidity();

      return;
    }

    this.shareToInstitutionForm.controls.institution_user_id.clearValidators();
    this.shareToInstitutionForm.controls.verify_address.clearValidators();

    this.shareToInstitutionForm.controls.certificate_.markAsDirty();
    this.shareToInstitutionForm.controls.institution.markAsDirty();
    this.shareToInstitutionForm.controls.country.markAsDirty();
    this.shareToInstitutionForm.controls.institutionemail.markAsDirty();
    this.shareToInstitutionForm.controls.address.markAsDirty();

    this.shareToInstitutionForm.controls.institution_user_id.updateValueAndValidity();
    this.shareToInstitutionForm.controls.verify_address.updateValueAndValidity();
    this.shareToInstitutionForm.controls.certificate_.updateValueAndValidity();
    this.shareToInstitutionForm.controls.institution.updateValueAndValidity();
    this.shareToInstitutionForm.controls.country.updateValueAndValidity();
    this.shareToInstitutionForm.controls.institutionemail.updateValueAndValidity();
    this.shareToInstitutionForm.controls.address.updateValueAndValidity();
  }

  patchInstitutionForm() {
    let body: any;
    body = {
      candidate_id: this.shareToInstitutionForm.controls.candidate_id.value
        ? this.shareToInstitutionForm.controls.candidate_id.value
        : this.candidate_id_,
      certificate: this.shareToInstitutionForm.controls.candidate_id.value
        ? this.shareToInstitutionForm.controls.candidate_id.value
        : this.candidate_id_,
      institution: this.shareToInstitutionForm.controls.institution.value,
      institution_name: this.shareToInstitutionForm.controls.institution.value,
      country: this.shareToInstitutionForm.controls.country.value,
      institutionemail:
        this.shareToInstitutionForm.controls.institutionemail.value,
      email: this.shareToInstitutionForm.controls.institutionemail.value,
      address: this.shareToInstitutionForm.controls.address.value
        ? this.shareToInstitutionForm.controls.address.value
        : this.shareToInstitutionForm.controls.verify_address.value,
      additional_info:
        this.shareToInstitutionForm.controls.additional_info.value,
      institution_user_id:
        this.shareToInstitutionForm.controls.institution_user_id.value,

      share_type: ShareType.INSTITUTION,
    };
    return body;
  }

  shareCertToInstitution() {
    const isSwitchOff = this.shareToInstitutionForm.value?.switch;
    this.userInformationModal = false;
    this.loading = true;
    this.error = "";
    localStorage.removeItem(StorageKeys.DISPLAY_PAYMENT_STEP);
    this.checkInstitutionFormValidity(isSwitchOff);

    if (this.shareToInstitutionForm.invalid) {
      this.loading = false;
      return;
    }

    let body = this.patchInstitutionForm();
    this.profileSrv.clearInputDetailsTemporarily();
    this.profileSrv.storeInputDetailsTemporarily(body);
    this.onValidateEmail({
      email: body.institutionemail,
      institution_name: body.institution,
      ...body,
    });
    this.loading = false;
  }

  onValidateEmail(payload: any) {
    this.profileService
      .validateEmail(payload)
      .then((res: any) => {
        if (res?.status === ResponseStatus.FAILED) {
          this.notify.error("", res?.message);
          return;
        }

        if (res?.data?.can_share) {
          this.getServiceChargeInformation();
        } else {
          this.notify.info("", res?.data?.reason);
        }
      })
      .catch((err: any) => {
        console.warn(err);
      });
  }

  getShareInformation() {
    let result: any;
    if (
      this.shareCertificateOptionSelected ===
      ShareCertificateOptions.REQUEST_CONFIRMATION
    ) {
      result = this.certificateList.filter(
        (c) => c.id == this.shareToInstitutionForm.value?.certificate_,
      )[0];
      this.candidateInformation = {
        ...result,
        ...this.shareToInstitutionForm.value,
      };
      return;
    }

    result = this.certificateList.filter(
      (c) => c.id == this.shareForm.value?.certificate,
    )[0];
    this.candidateInformation = { ...result, ...this.shareForm.value };
  }

  getServiceChargeInformation() {
    if (
      this.shareCertificateOptionSelected ===
        ShareCertificateOptions.REQUEST_CONFIRMATION &&
      this.shareToInstitutionForm.controls.country.value != this.userCountry.code
    ) {
      this.serviceCharge = this.currencyPipe.transform(
        this.currency_unit_rate * this.requestConfirmationCost!,
        this.payment_currency,
      );
      this.costInUnit = this.requestConfirmationCost;
    } else {
      this.serviceCharge = this.currencyPipe.transform(
        this.currency_unit_rate * this.shareCost!,
        this.payment_currency,
      );
      this.costInUnit = this.shareCost;
    }

    this.getShareInformation();
    // this.userInformationModal = true;
    this.processStepsModal = true;
  }

  selectedShareCertificateOption(option: string) {
    this.shareCertificateOptionSelected = option.toLowerCase();
    this.storageSrv.setLocalStorageItem(StorageKeys.SHARE_OPTION, option.toLowerCase());
    this.profileSrv.storeInputDetailsTemporarily(this.shareForm.value);
    this.profileSrv.clearInputDetailsTemporarily();
    this.shareForm.reset();
    this.shareToInstitutionForm.reset();
    this.resetShareState();
    this.storageSrv.setLocalStorageItem(StorageKeys.SHARE_OPTION, option.toLowerCase());
  }

  checkScreenSize() {
    if (window.screen.width < 480) {
      this.isSmallScreen = true;
      this.displayScrollToTop = true;
      this.pipeDateFormart = "d MMMM";
      return;
    }

    if (window.screen.width <= 1280 && window.screen.width >= 1024) {
      this.isSmallScreen = true;
      this.pipeDateFormart = "d MMMM";
      return;
    }

    this.displayScrollToTop = false;
    this.isSmallScreen = false;
    this.pipeDateFormart = "d MMM";
  }

  getInstitutions(query?: any) {
    const param = query ? query : this.searchInstitutionsForm.value;
    this.certificateService
      .searchInstitutions(param)
      .then(async (res: any) => {
        if (res?.status === ResponseStatus.FAILED) {
          this.notify.info("", res?.message);
          return;
        }

        if (res?.data.name !== null) {
          this.emailInstitutionList = [];
          res?.data.forEach((data: any) => {
            this.emailInstitutionList.push({
              name: data.name,
              id: data.id,
              email: data.email,
              country: data.country,
              account_name: data?.account_name,
            });
          });
        }
        this.institutions = res?.data;
        this.isInstitutionLoading = false;
      })
      .catch((err) => {
        console.error(err?.error?.message);
      });
  }

  searchForEmailInstitution(event: any) {
    if (event.length) {
      this.isInstitutionLoading = true;
      this.searchInstitutionsForm.patchValue({
        search: event,
      });
      this.getInstitutions(this.searchInstitutionsForm.value);
    }
  }

  onSelectInstitution(event: any) {
    const option = this.institutions.filter((e) => e.id === event);
    this.shareToInstitutionForm.patchValue({
      institutionemail: option[0]?.email,
      country: option[0]?.country,
      institution: option[0]?.name,
    });

    if (option[0]?.institution_detail.address !== null) {
      this.isAddressNotAvailable = false;
      return;
    }

    this.isAddressNotAvailable = true;
  }

  onToggleSwitch(event: any) {
    this.isInstitutionNotAvailable = event;
    this.shareToInstitutionForm.patchValue({
      additional_info: null,
      institution: null,
      country: null,
      address: null,
      institutionemail: null,
      email: null,
      institution_user_id: null,
      verify_address: null,
    });
    this.institutionAvailablityInfo = event
      ? this.translate.instant("PROVISIONING.SHARE.TOGGLE_SWITCH")
      : this.translate.instant("PROVISIONING.SHARE.TOGGLE_SWITCH_DESCRIPTION");
  }

  getCost() {
    const country = this.shareToInstitutionForm.value.country;
    if (
      this.shareCertificateOptionSelected ===
        ShareCertificateOptions.REQUEST_CONFIRMATION &&
      country !== this.userCountry?.code
    ) {
      return this.requestConfirmationCost;
    } else if (
      this.shareCertificateOptionSelected === ShareCertificateOptions.INDIVIDUAL
    ) {
      return this.shareCost;
    } else {
      return this.shareCost;
    }
  }

  onViewMoreHistory() {
    const screenSize = window.screen.width;
    if (screenSize >= 480) {
      this.router.navigate([pageRoutes.access.shareHistory]);
      return;
    }

    if (this.loading) {
      return;
    }

    this.loading = true;
    let page = this.current_page + 1;
    let page_size = 7;
    let url = `?page=${page}&page_size=${page_size}`;

    this.certificateService
      .sharedCertificate(url)
      .then((res) => {
        if (res.error) {
          this.notify.error("", res.error);
          this.isloading = false;
          return;
        }

        this.current_page = res?.data?.pagination?.current_page;
        if (res?.data?.data.length) {
          res?.data?.data.forEach(async (data: any) => {
            await this.sharedHistory.push(data);
          });

          this.loading = false;
        }
      })
      .catch(() => {
        this.isloading = false;
      });
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: scrollBehaviours.SMOOTH });
  }

  async checkBalanceInitiatePayment() {
    const wallet = await this.storageSrv.getLocalStorageItem(
      BrowserStorageKeys.token,
    )?.wallet;
    const balance = await wallet?.unit_balance;

    if (balance <= 0) {
      this.paymentModal = true;
    } else {
      this.confirmSubmission();
    }
  }

  closeConfirmInformation() {
    this.userInformationModal = false;
    this.showCertificate = false;
  }

  closeProcessStepsModal() {
    this.processStepsModal = false;
  }

  closeExamCountrySetupModal() {
    this.examCountrySetupModal = false;
  }
}
